<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo" :board="this.board" :is-print="isPrint"/>

    <div class="mt-component-form">
      <vs-row class="my-4">
        <vs-col><h5><i class="dot"></i>비상조치계획 개요</h5></vs-col>
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">장소</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
          <vs-input
            v-else
            v-model="form.inputB_1"
            class="w-full flex-1"
          ></vs-input>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">점검일</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
          <date-selector
            :readonly="board.readonly"
            v-else
            v-model="form.inputB_2"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">재해형태</div>
          <p v-if="isPrint" class="print-input" style="color:red;"> {{ form.inputB_3 }} </p>
          <disaster-class-selector
            v-else
            class="w-full flex-1"
            :readonly="board.readonly"
            v-model="form.inputB_3"
            style="color: red;"
          />
        </div>

      </div>
    </div>
    <!--    점검대상-->
<!--    <vs-row class="mt-6">-->
<!--      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">-->
<!--        <h5>-->
<!--          <i class="dot"></i> 점검대상-->
<!--        </h5>-->
<!--      </vs-col>-->
<!--    </vs-row>-->

<!--    <div class="gap-x-6 gap-y-4 mt-4">-->
<!--      <span v-if="isPrint"> {{form.inspectionTitle}} </span>-->
<!--      <div class="ml-group-checkBox flex flex-wrap w-full flex-1" v-else>-->
<!--        <vs-checkbox-->
<!--          class="mr-1 mb-2"-->
<!--          :readonly="board.readonly">-->
<!--          {{form.inspectionTitle}}-->
<!--        </vs-checkbox>-->
<!--      </div>-->
<!--    </div>-->

    <!--    비상조치계획 수립-->
    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="form.inspectionTitle"
      :list="form.inspectList"
      :is-note="false"
      :table-header-title="'점검 내용'"
      :table-header-yes="'양호'"
      :table-header-no="'미흡'"
      :table-header-na="'해당없음'"
      :table-header-note="'비고(보완계획)'"
      @update-list-check="updateListCheck"
      @update-note="updateListNote"
    />

    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"/>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableInspect from '@/components/TableInspect'
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";

export default {
  components: {
    DisasterClassSelector,
    FileUploadModule,
    TableInspect,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
    PhotoUploadGridModule
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }

        this.form.inspectionTitle = this.inspectionTitle
        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      inspectionTitle:'비상조치계획 점검표',
      form: {
        inspectionTitle:'비상조치계획 점검표',
        inputB_1: '',
        inputB_2: '',
        inputB_3: '',
        stdInfo: { },
        photoList: [],
        fileList: [],
        equipmentList: [],
        inspectList: []
      },
    }
  },
  computed: {
    inspectTable () {
      return  [
        {
          id: 1,
          label: '위험요인별로 어떤 재해가 발생할 수 있는지를 검토하여 중대재해로 이어질 수 있는 재해요인 파악',
          is_checked: '',
          note: '',
        },
        {
          id: 2,
          label: '발생 가능한 사고의 유형 및 형태, 사고 발생 시 초래될 결과 등 확인･예측',
          is_checked: '',
          note: '',
        },
        {
          id: 3,
          label: '본청･사업소별 위험성이 높은 위험요인에 대해 재해발생 시나리오 작성',
          is_checked: '',
          note: '',
        },
        {
          id: 4,
          label: '재해발생 시나리오별 조치계획을 작성하여 관계 부서, 공정, 유해･위험물질, 재해유형, 원인, 피해범위 등을 목록화하여 관리',
          is_checked: '',
          note: '',
        },
        {
          id: 5,
          label: '비상조치계획에는 필요한 인력 및 시설･장비(인적･물적 자원)를 적절히 포함',
          is_checked: '',
          note: '',
        },
        {
          id: 6,
          label: '비상조치계획에 작업중지･근로자 대피･위험요인 제거 등 대응조치, 재해자구호조치, 추가피해 방지를 위한 조치 포함',
          is_checked: '',
          note: '',
        },
        {
          id: 7,
          label: '비상조치계획에 상황 보고 및 전파체계, 조치별 대응조직 및 담당자의역할 구분',
          is_checked: '',
          note: '',
        },
        {
          id: 8,
          label: '비상시 즉각 탈출할 수 있는 비상구가 충분히 마련되었고, 즉각 알아볼 수 있는 형태로 표시',
          is_checked: '',
          note: '',
        },
        {
          id: 9,
          label: '비상상황에 대비한 병원, 소방서 등 유관 기관과의 협조체계 마련',
          is_checked: '',
          note: '',
        },
        {
          id: 10,
          label: '비상조치계획에 따라 주기적으로 훈련하고 적정성 검토(반기 1회 이상) 및 이행',
          is_checked: '',
          note: '',
        },
        {
          id: 11,
          label: '훈련과정에서 발견된 문제점을 검토하여 개선 조치 이행',
          is_checked: '',
          note: '',
        },
      ]

    },
  },
  methods : {
    updateList (list) {
      this.form.equipmentList = list
    },
    updateListCheck (indexRows, text) {
      this.form.inspectList[indexRows].is_checked = text
    },
    updateListNote (indexRows, text) {
      this.form.inspectList[indexRows].note = text
    }
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px 14px 4px;
  }
}
</style>
